import * as React from "react";
import { default as ClientRepo, IConfigurationData } from "../data/client";

interface IClientProps {
    data: ClientRepo,
    handleError: (e:any) => void
}

interface IState {
    configuration: IConfigurationData,
    zoom?: string
}

export default class Clients extends React.Component<IClientProps, IState> {
    public state: IState = {
        configuration: {
            clients: {},
            resources: {}
        }
    };

    private isActive = true;

    constructor(props: IClientProps) {
        super(props);
        this.props.data.GetAll()
            .then(d => d && this.isActive && this.setState({ configuration: d }))
            .catch(this.props.handleError);
    }

    public componentWillUnmount() {
        this.isActive = false;
    }

    public render() {
        const resources = this.state.configuration.resources;
        const clients = this.state.configuration.clients;

        const toggleDetails = (id: string) =>
            this.setState({ zoom: this.state.zoom !== id ? id : undefined })

        return <div className="content">
            <h1>API-ressurser</h1>
            <div className="list">
                {
                    Object.keys(this.state.configuration.resources).map(k =>
                        <div className="resource" key={k}>
                            <div className="id">{k}</div>
                            <div className="name">{resources[k].displayName}</div>
                        </div>)
                }
            </div>
            <h1>Klienter</h1>
            <div className="list">{
                Object.keys(this.state.configuration.clients).map(k =>
                    // tslint:disable-next-line:jsx-no-lambda
                    <div className="client" key={k} onClick={() => toggleDetails(k)} >
                        <div className="id">{k}</div>
                        <div className="name">{clients[k].clientName}</div>
                        {
                            this.state.zoom === k &&
                            <div className="details">
                                <div>Tillat adgangstoken via nettleser: {
                                    clients[k].allowAccessTokensViaBrowser ? "Ja" : "Nei"
                                }</div>
                                {
                                    clients[k].allowedGrantTypes && clients[k].allowedGrantTypes.length > 0 &&
                                    <div className="box"><h1>Grant types</h1> {
                                        clients[k].allowedGrantTypes.map(t =>
                                            <div key={t}>{t}</div>)
                                    }
                                    </div>
                                }
                                {
                                    clients[k].allowedScopes && clients[k].allowedScopes.length > 0 &&
                                    <div className="box"><h1>Scopes</h1> {
                                        clients[k].allowedScopes.map(t =>
                                            <div key={t}>{t}</div>)
                                    }
                                    </div>
                                }
                                {
                                    clients[k].redirectUris && clients[k].redirectUris.length > 0 &&
                                    <div className="box"><h1>Login URIs</h1> {
                                        clients[k].redirectUris.map(t =>
                                            <div key={t}>{t}</div>)
                                    }
                                    </div>
                                }
                                {
                                    clients[k].postLogoutRedirectUris && clients[k].postLogoutRedirectUris.length > 0 &&
                                    <div className="box"><h1>Logout URIs</h1> {
                                        clients[k].postLogoutRedirectUris.map(t =>
                                            <div key={t}>{t}</div>)
                                    }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                )}
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/clients/clients.tsx